namespace GeniuzPOS.Inventory {
    export enum AdjFgstatus {
        QtybyAvg = 0,
        Qtyonly = 1,
        Priceonly = 2,
        QtyandPrice = 3
    }
    Serenity.Decorators.registerEnumType(AdjFgstatus, 'GeniuzPOS.Inventory.AdjFgstatus');
}
